import React from "react";
import { PageHeader } from "antd";
import JcpEnrollmentEntry from "../../components/enrollment/jcp/JcpEnrollmentEntry";
import AdminBreadCrumb from "../../components/layout/AdminBreadCrumb";
import ScheduleChangeComp from "../../components/enrollment/ScheduleChangeComp";
import OpeningBalanceEntryView from "../../components/opening-balance/OpeningBalanceEntryView";

const ProgramWiseOpeningBalance = () => {
  return (
    <div className="inside-main-content">
      <AdminBreadCrumb />

      <div className="box-style">
        <PageHeader
          ghost={false}
          onBack={() => window.history.back()}
          title="Opening Balance"
          subTitle=""
          extra={[]}
        ></PageHeader>

        <OpeningBalanceEntryView />
      </div>
    </div>
  );
};

export default ProgramWiseOpeningBalance;
